module.exports = __webpack_public_path__ + "img/home-3.ce57f5e4.png";